<div class="container-fluid mt-4">
  <div class="row">
    <!-- Columna de la lista de trabajos -->
    <div class="col-lg-4 col-md-12 mb-3">
      <h4>Órdenes Listas</h4>
      <div class="mb-3">
        <input type="text" class="form-control form-control-sm" placeholder="Buscar por cliente, N° caso..." [formControl]="workSearchControl" />
      </div>
      <div class="list-group ready-list">
        <ng-container *ngIf="filteredWorks$ | async as works; else loadingWorksTemplate">
          <div *ngIf="works.length > 0; else noWorksFoundTemplate">
            <a *ngFor="let work of works" href="javascript:void(0);" class="list-group-item list-group-item-action" [class.active]="(selectedWorkId$ | async) === work.id" (click)="selectWork(work)">
              <div class="d-flex w-100 justify-content-between">
                <h5 class="mb-1 text-truncate">{{ work.caseNumber }} - {{ work.clientName }}</h5>
                 <div>
                <span *ngIf="work.currentStatus === 'Handed Off'" class="badge bg-success" title="Bici entregada"><i class="bi bi-check2-circle"></i></span>
                <span *ngIf="work.billingStatus === 'billed'" class="badge bg-success me-1" title="Facturado" style="margin-left: 2px;"><i class="bi bi-currency-dollar"></i></span>
                <span *ngIf="work.notifiedStatus != 'notified'" class="badge bg-danger" title="Cliente sin notificar">PENDIENTE NOTIFICAR</span>
                <span *ngIf="work.notifiedStatus === 'notified'" class="badge bg-primary" title="Cliente Notificado"><i class="bi bi-envelope-check-fill"></i></span>
              </div>
              </div>
             
              <p class="mb-1 small text-truncate">{{ work.bikeDescription }}</p>
            </a>
          </div>
          <ng-template #noWorksFoundTemplate>
            <div class="list-group-item">No hay trabajos con el estado "Lista".</div>
          </ng-template>
        </ng-container>
        <ng-template #loadingWorksTemplate>
          <div class="list-group-item">Cargando trabajos...</div>
        </ng-template>
      </div>
    </div>

    <!-- Columna de detalles del trabajo -->
    <div class="col-lg-8 col-md-12">
      <div *ngIf="(selectedWorkId$ | async); else noWorkSelected">
        <ng-container *ngIf="{ work: (selectedWorkDetails$ | async), client: (selectedClientDetails$ | async), bike: (selectedBikeDetails$ | async) } as details; else loadingDetails">
          <div *ngIf="details.work && details.client && details.bike" class="card">
            <div class="card-header d-flex justify-content-between align-items-center">
              <h4 class="mb-0 text-truncate">Detalles: {{ details.work.caseNumber }}</h4>
              <div class="d-flex align-items-center">
  <!-- NUEVO: Switch de Facturación -->
  <div class="form-check form-switch me-3">
    <input class="form-check-input" style="cursor: pointer" type="checkbox" role="switch" id="billingStatusSwitchReady"
           [checked]="details.work.billingStatus === 'billed'"
           (change)="onBillingStatusChange($event, details.work)"
           [disabled]="isUpdatingBillingStatus">
    <label class="form-check-label" for="billingStatusSwitchReady">
      {{ details.work.billingStatus === 'billed' ? 'Facturado' : 'Pendiente facturar' }}
    </label>
  </div>

  <!-- Switch de Notificado (existente) -->
  <!-- NUEVO: Botón para Notificar Cliente -->
<button class="btn btn-sm btn-outline-info" 
        (click)="openNotificationModal(details.work)"
        [disabled]="details.work.notifiedStatus === 'notified'">
  <i class="bi bi-bell-fill me-1"></i>
  {{ details.work.notifiedStatus === 'notified' ? 'Notificado' : 'Notificar Cliente' }}
</button>

  <!-- NUEVO: Botón de Imprimir Reporte -->
  <button class="btn btn-sm btn-outline-primary ms-2" (click)="printWork(details.work, details.client, details.bike)" title="Imprimir Detalles">
    <i class="bi bi-printer-fill me-1"></i> Imprimir Reporte
  </button>
</div>
            </div>
            <div class="card-body">
              <div class="row mb-3">
                <div class="col-md-6">
                  <p><strong>Cliente:</strong> {{ details.client.name }}</p>
                  <p><strong>Bicicleta:</strong> {{ details.bike.brand }} {{ details.bike.model || '' }} - {{ details.bike.color }}</p>
                   <p><strong>Descripción:</strong> {{ details.work.description }}</p>
                   <p><strong>Tipo servicio:</strong> {{ details.work.serviceType }}</p>
                </div>
                <div class="col-md-6">
                  <p><strong>Recepción:</strong> {{ details.work.entryDate?.toDate() | date:'medium':'':'es-DO' }}</p>
                  <p><strong>Total:</strong> {{ details.work.totalPrice | currency:'DOP':'RD$' }}</p>
                </div>
              </div>

              <h5 class="mt-4">Artículos Agregados</h5>
              <ul *ngIf="details.work.addedItems?.length; else noItemsAdded" class="list-group">
                <li *ngFor="let item of details.work.addedItems" class="list-group-item d-flex justify-content-between align-items-center">
                  <div>{{item.productId}} - {{ item.productName }} (x{{ item.quantity }})</div>
                  <small class="text-muted d-block mt-1" *ngIf="item.mechanicName || item.assistantName">
                      <i class="bi bi-person-fill"></i> 
                      {{ item.mechanicName ? 'Mec: ' + item.mechanicName : '' }}
                      {{ item.mechanicName && item.assistantName ? ' | ' : '' }}
                      {{ item.assistantName ? 'Asis: ' + item.assistantName : '' }}
                    </small>
                    <div class="d-flex align-items-center">
                  <span>{{ item.unitPrice * item.quantity | currency:"DOP":"RD$" }}</span>
                  </div>
                </li>
              </ul>
              <ng-template #noItemsAdded><p>No se han agregado artículos a este trabajo.</p></ng-template>

              <!-- Sección de Estados y Recordatorio de Artículos del Cliente -->
              <hr>
              <div class="row align-items-start">
                <div class="col-lg-7 col-md-12 mb-3">
                  <h5>Estado del trabajo</h5>
                  <ng-container *ngIf="selectedWorkStatus$ | async as statusDoc">
                    <p><strong>Estado Actual:</strong> {{ getSpanishStatus(statusDoc.currentStatus) }}</p>
                    <form [formGroup]="statusChangeForm" (ngSubmit)="onSubmitStatusChange()" class="mb-3">
                      <div class="input-group input-group-sm">
                        <select class="form-select" formControlName="newStatus">
                          <option value="" disabled>Cambiar estado a...</option>
                          <option *ngFor="let statOpt of availableStatusesForChange" [value]="statOpt.value">{{ statOpt.display }}</option>
                        </select>
                        <button type="submit" class="btn btn-warning" [disabled]="statusChangeForm.invalid || isUpdatingStatus">Actualizar</button>
                      </div>
                    </form>
                  </ng-container>
                  <h5 class="text-secondary"><i class="bi bi-clock-history me-2"></i>Historial de Estados</h5>
                  <ng-container *ngIf="selectedWorkStatus$ | async as statusDoc; else noStatusFound">
                    <div *ngIf="statusDoc.history?.length" class="mt-3 mb-2">
                      <ul class="list-group list-group-flush status-history-list border rounded">
                        <li *ngFor="let entry of statusDoc.history" class="list-group-item list-group-item-light py-2">
                          <div class="d-flex w-100 justify-content-between">
                            <small class="fw-bold">{{ getSpanishStatus(entry.status) }}</small>
                            <small>{{ entry.timestamp?.toDate() | date:'dd/MM/yy hh:mm a':'':'es-DO' }}</small>
                          </div>
                          <small *ngIf="entry.notes" class="d-block text-muted fst-italic">Notas: {{ entry.notes }}</small>
                        </li>
                      </ul>
                    </div>
                  </ng-container>
                  <ng-template #noStatusFound>
                    <div class="alert alert-light border small text-muted">No se encontró información de estado para esta orden.</div>
                  </ng-template>
                </div>

                <div class="col-lg-5 col-md-12">
                  <!-- Recordatorio de artículos dejados por el cliente -->
                  <div class="card border-warning-subtle shadow-sm bg-warning bg-opacity-10">
                    <div class="card-header bg-warning bg-opacity-25 py-2 d-flex justify-content-between align-items-center border-bottom border-warning-subtle">
                      <span class="fw-bold text-dark small">
                        <i class="bi bi-box-seam text-warning-emphasis me-1"></i> Artículos del Cliente (Devolver)
                      </span>
                      <span class="badge bg-warning text-dark border border-warning" *ngIf="details.work.clientItems?.length">
                        {{ details.work.clientItems!.length }}
                      </span>
                    </div>
                    <div class="card-body p-2">
                      <div *ngIf="details.work.clientItems && details.work.clientItems.length > 0; else noClientItemsReady">
                        <p class="small text-muted mb-2"><i class="bi bi-info-circle me-1"></i>Recordatorio: devolver al cliente al entregar la bicicleta:</p>
                        <ul class="list-group list-group-flush rounded border">
                          <li *ngFor="let item of details.work.clientItems" class="list-group-item list-group-item-light py-1 px-2 small d-flex align-items-center">
                            <i class="bi bi-arrow-return-right text-warning-emphasis me-2"></i>
                            <span class="fw-semibold">{{ item }}</span>
                          </li>
                        </ul>
                      </div>
                      <ng-template #noClientItemsReady>
                        <p class="small text-muted mb-0 fst-italic py-1">
                          <i class="bi bi-dash-circle me-1"></i>Sin artículos adicionales registrados por el cliente.
                        </p>
                      </ng-template>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </ng-container>
        <ng-template #loadingDetails>
          <div class="text-center p-5">Cargando detalles...</div>
        </ng-template>
      </div>
      <ng-template #noWorkSelected>
        <div class="alert alert-info">Seleccione un trabajo de la lista para ver sus detalles.</div>
      </ng-template>
    </div>
  </div>
</div>
<div class="modal fade" #notificationModal id="notificationModal" tabindex="-1" aria-labelledby="notificationModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="notificationModalLabel">Opciones de Notificación</h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Cerrar"></button>
      </div>
      <div class="modal-body">
        <p>¿Cómo deseas notificar al cliente sobre la orden <strong>{{ workForNotification?.caseNumber }}</strong>?</p>
        
        <div class="d-grid gap-2">
          <button class="btn btn-success" (click)="onNotifyByWhatsapp()" [disabled]="isUpdatingNotifiedStatus">
            <span *ngIf="isUpdatingNotifiedStatus" class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
            <i class="bi bi-whatsapp me-1"></i> Marcar como Notificado (WhatsApp/Llamada)
          </button>

          <button class="btn btn-primary" (click)="onNotifyByEmail()" [disabled]="isUpdatingNotifiedStatus || !clientForNotification?.email">
  <span *ngIf="isUpdatingNotifiedStatus" class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
  <i class="bi bi-envelope-fill me-1"></i> Enviar Notificación por Correo
</button>
<small *ngIf="!clientForNotification?.email" class="form-text text-muted text-center">
  El cliente no tiene un correo registrado para esta opción.
</small>
        </div>

      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Cancelar</button>
      </div>
    </div>
  </div>
</div>